import { useEffect, useState } from "react"
import API from "./API"
import { AdminQueryCenter, AdminQueryDivision, AdminQueryProduct, AdminQueryProject } from "../../backend/src/api/dto"
import dayjs from 'dayjs'
import { lookupNameFromObjectsArray } from "./global"
import { Link } from "react-router"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { yesNo, openClosed } from "./constants"
import AdminLevel from "./AdminLevel"
import { TableColumn } from "./interfaces"
import TableData from "./components/TableData"

function Projects() {
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<{
        projects: AdminQueryProject[],
        centers: AdminQueryCenter[],
        products: AdminQueryProduct[],
        divisions: AdminQueryDivision[],
    }>({
        projects: [],
        centers: [],
        products: [],
        divisions: [],
    })

    useEffect(() => {
        setLoading(true);
        Promise.all([

            API.getProjects({ divisionMatch: 'true' }),
            API.getCenters(),
            API.getProducts(),
            API.getDivisions()
        ]).then(res => {
            setLoading(false);
            setData({
                projects: res[0],
                centers: res[1],
                products: res[2],
                divisions: res[3],
            })
        }).catch(() => {
            setLoading(false);
        });
    }, [])

    

    const tableColumns: TableColumn[] = [
        { key: 'nameId', title: 'ID' },
        { key: 'name', title: 'Projekt', fn: (project: AdminQueryProject) => <Link to={"/dashboard/project/" + project.projectId}>{project.name}</Link> },
        { key: 'centerId', title: 'Stredisko', fn: (project: AdminQueryProject) => lookupNameFromObjectsArray(data.centers, 'centerId', project.centerId) },
        { key: 'divisionId', title: 'Divízia', fn: (project: AdminQueryProject) => lookupNameFromObjectsArray(data.divisions, 'divisionId', project.divisionId) },
        { key: 'ordersIndicator', title: 'Komponenty', className: 'text-center', fn: (project: AdminQueryProject) => lookupNameFromObjectsArray(yesNo, 'id', project.ordersIndicator) },
        { key: 'responsible', title: 'Zodpovený' },
        { key: 'customer', title: 'Zákazník' },
        { key: 'billingCustomer', title: 'Zákazník FV' },
        { key: 'productId', title: 'Produkt', fn: (project: AdminQueryProject) => lookupNameFromObjectsArray(data.products, 'productId', project.productId) },
        { key: 'startDate', title: 'Štart', className: (project: AdminQueryProject) => project.stillWorks ? 'bg-success-subtle' : '', fn: (project: AdminQueryProject) => project.startDate ? dayjs(project.startDate).format('YYYY-MM-DD') : null },
        { key: 'endDate', title: 'Koniec', fn: (project: AdminQueryProject) => project.endDate ? dayjs(project.endDate).format('YYYY-MM-DD') : null },
        { key: 'status', title: 'Stav', className: 'text-center', fn: (project: AdminQueryProject) => lookupNameFromObjectsArray(openClosed, 'id', project.status) },
        { key: 'actions', title: 'Akcia', className: 'text-center', style: { width: '110px' }, fn: (project: AdminQueryProject) => <Link className="btn btn-primary btn-sm" to={"/dashboard/project/" + project.projectId}><FontAwesomeIcon fixedWidth icon={["fas", "pen"]} /> Upraviť</Link> }
    ]


    return (
        <div className="p-3">
            <div className="card">
                <div className="card-header" style={{ height: '55px' }}>
                    <div className="row">
                        <div className="col-6">
                            <h5 className="mt-2">
                                <FontAwesomeIcon fixedWidth icon={["fas", "diagram-project"]} /> Projekty
                            </h5>
                        </div>
                        <div className="col-6 text-end">
                            <AdminLevel level={9} match="greaterOrEqual">
                                <Link to="/dashboard/project/0" className="btn btn-success"><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} /> Pridať projekt</Link>
                            </AdminLevel>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <TableData tableColumns={tableColumns}rows={data.projects} data={data} loading={loading} />
                </div>
            </div>
        </div>
    )
}



export default Projects